import React from "react";
import { matchPath } from "react-router-dom";
import { ReactComponent as Icon } from "../files/registration-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const RegistrationIcon = ({
    fill,
    active = "",
    path = "NO_ADDRESS_PROVIDED",
    style = {},
}: ISVGIconProps) => {
    const match = matchPath(
        {
            path: path,
        },
        window.location.pathname
    );
    return (
        <Icon
            fill={match && path !== "NO_ADDRESS_PROVIDED" ? active : fill}
            style={style}
        />
    );
};

export default RegistrationIcon;
